module.exports = {
    // -- INIT ---
	publicPath: '/',
	// -- END ---
    
    // publicPath: '/',
    css: { extract: false },
    lintOnSave: false
}